module.exports = __WEBPACK_EXTERNAL_MODULE_19__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 19
// module chunks = 0 1